<span class="css-table-column-left">{{value}}</span>&nbsp;<span class="css-table-column-right">{{unit}}</span>
<div class="pull-right {{#unless isEditable}}camouflage{{/unless}}">
	<div {{#unless isInconsistent}}id="js-edit-{{id}}" {{/unless}}
		class="btn btn-{{buttonColor}} btn-sm js-edit-value">
		<i class="{{icon}}"></i>
	</div>
</div>